import { memo, useCallback } from 'react';

import { useTranslation } from 'react-i18next';

import { isKeyEnter } from '@/util/util';

type AuthGuidelinesLinkProps = { onClick: (e: React.MouseEvent) => void };

const AuthGuidelinesLink = memo(({ onClick }: AuthGuidelinesLinkProps) => {
  const { t } = useTranslation();

  const handleKeyUp = useCallback(
    (e: React.KeyboardEvent) => {
      if (isKeyEnter(e)) {
        onClick(e as unknown as React.MouseEvent);
      }
    },
    [onClick]
  );

  return (
    <div
      className="mr-auto flex w-fit cursor-pointer items-center pt-2 text-xs text-primary hover:underline"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyUp={handleKeyUp}
      data-testid="auth-guidelines-link"
    >
      <span>
        {t('dialog.auth.guidelines')} {'→'}
      </span>
    </div>
  );
});

AuthGuidelinesLink.displayName = 'AuthGuidelinesLink';

export default AuthGuidelinesLink;
